// Nav for public pages
// Add color and border to public top nav on scroll
export default function() {

  $(window).scroll(function() {

    if ($(window).scrollTop() > 30) {

      return $('.navbar.nav-top').addClass('nav-bordered');

    } else {

      return $('.navbar.nav-top').removeClass('nav-bordered');
    }

  });

}